import React from 'react';
import PropTypes from 'prop-types';
import ItemFlagButton from './ItemFlagButton';
import questionDisplayFlagSelector from '../../../selectors/question/itemFlags/QuestionDisplayFlagSelector';

const QuestionDisplayFlagPure = (props) => {
    const {
        currentScorableItem,
        extraClassList,
        scorableItems,
        showFlagging,
        useNumberPerInteraction,
    } = props;

    const classList = [...extraClassList];
    if (!showFlagging) {
        classList.push('flags-disabled');
    }

    const getItemFlagButton = item => (
        <ItemFlagButton
            orderNumber={item.orderNumber}
            isCurrentItem={currentScorableItem === item.orderNumber}
            key={item.orderNumber}
            itemIdentifier={item.responseIdentifier}
            {...props}
        />
    );

    return (
        <div className={classList.join(' ')}>
            { showFlagging && (
                useNumberPerInteraction
                    ? scorableItems.map(getItemFlagButton)
                    : <ItemFlagButton {...props} />
            )}
        </div>
    );
};

QuestionDisplayFlagPure.propTypes = {
    currentScorableItem: PropTypes.number,
    extraClassList: PropTypes.array.isRequired,
    isHorizontal: PropTypes.bool,
    noTitle: PropTypes.bool,
    question: PropTypes.object,
    responseIdentifier: PropTypes.string,
    scorableItems: PropTypes.array,
    showFlagging: PropTypes.bool.isRequired,
    useNumberPerInteraction: PropTypes.bool.isRequired,
    viewMedia: PropTypes.string.isRequired,
};

const QuestionDisplayFlag = props => (
    <QuestionDisplayFlagPure {...props} {...questionDisplayFlagSelector.selectProps(props)} />
);

export default QuestionDisplayFlag;
